import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "d-flex justify-content-end align-items-end" }
const _hoisted_8 = { class: "overflow-auto" }
const _hoisted_9 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_10 = { class: "draggable" }
const _hoisted_11 = { style: {"width":"0"} }
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]
const _hoisted_14 = {
  key: 2,
  class: "fa fa-stop-circle text-danger ms-1"
}
const _hoisted_15 = ["title"]
const _hoisted_16 = { style: {"width":"0"} }
const _hoisted_17 = { style: {"width":"0"} }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = {
  key: 0,
  class: "badge bg-primary me-1"
}
const _hoisted_21 = {
  key: 1,
  class: "badge bg-primary me-1"
}
const _hoisted_22 = {
  key: 2,
  class: "badge bg-primary me-1"
}
const _hoisted_23 = { class: "badge bg-primary me-1" }
const _hoisted_24 = { class: "badge bg-primary me-1" }
const _hoisted_25 = { class: "text-end" }
const _hoisted_26 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CascadeForm = _resolveComponent("CascadeForm")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_Sortable = _resolveComponent("Sortable")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary text-capitalize me-2",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.savePriority && _ctx.savePriority(...args)))
                    }, _toDisplayString(_ctx.helper.trans('button.save_order')), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showEditModal())),
                      class: "btn btn-sm btn-outline-primary text-nowrap text-capitalize"
                    }, _toDisplayString(_ctx.helper.trans('button.create')), 1)
                  ]),
                  _createVNode(_component_b_modal, {
                    title: _ctx.createModalTitle,
                    modelValue: _ctx.createModal,
                    "dialog-class": "modal-lg",
                    "body-class": "pt-0",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.createModal = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CascadeForm, {
                        ref: "createForm",
                        "provider-rating-enabled": _ctx.providerRatingEnabled
                      }, null, 8, ["provider-rating-enabled"])
                    ]),
                    footer: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createModal = false)),
                        class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
                      _createVNode(_component_LoaderWrapper, {
                        ref: "loaderCreateFrom",
                        zoom: 0.5
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.save())),
                            class: "btn btn-outline-primary btn-sm text-capitalize-first"
                          }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _: 1
                  }, 8, ["title", "modelValue"]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("table", _hoisted_9, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _cache[6] || (_cache[6] = _createElementVNode("th", null, null, -1)),
                          _cache[7] || (_cache[7] = _createElementVNode("th", null, null, -1)),
                          _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.title')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.helper.trans('labels.settings')), 1),
                          _cache[8] || (_cache[8] = _createElementVNode("th", { class: "text-end" }, null, -1))
                        ])
                      ]),
                      _createVNode(_component_Sortable, {
                        list: _ctx.cascades,
                        "item-key": "id",
                        onEnd: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onUpdate($event))),
                        tag: "tbody",
                        class: "",
                        options: {draggable: '.draggable', handle: '.drag-handle'}
                      }, {
                        item: _withCtx(({element, index}) => [
                          _createElementVNode("tr", _hoisted_10, [
                            _cache[11] || (_cache[11] = _createElementVNode("td", { style: {"width":"0"} }, [
                              _createElementVNode("div", { class: "drag-handle p-3 ps-4 pe-4" }, [
                                _createElementVNode("i", { class: "fa-solid fa-grip-vertical" })
                              ])
                            ], -1)),
                            _createElementVNode("td", _hoisted_11, [
                              (element.direction === _ctx.Direction.PAY_IN)
                                ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    title: _ctx.helper.trans(`direction.${element.direction}`),
                                    class: "fa-regular fa-circle-down text-primary"
                                  }, null, 8, _hoisted_12)), [
                                    [
                                      _directive_b_tooltip,
                                      void 0,
                                      void 0,
                                      { hover: true }
                                    ]
                                  ])
                                : _withDirectives((_openBlock(), _createElementBlock("i", {
                                    key: 1,
                                    title: _ctx.helper.trans(`direction.${element.direction}`),
                                    class: "fa-regular fa-circle-up text-warning"
                                  }, null, 8, _hoisted_13)), [
                                    [
                                      _directive_b_tooltip,
                                      void 0,
                                      void 0,
                                      { hover: true }
                                    ]
                                  ]),
                              (!element.enabled)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                                : _createCommentVNode("", true),
                              (element.beforeTraderRequisites)
                                ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                    key: 3,
                                    title: _ctx.helper.trans(`labels.cascadeBeforeTraderRequisites`),
                                    class: "fa fa-warning text-warning"
                                  }, null, 8, _hoisted_15)), [
                                    [
                                      _directive_b_tooltip,
                                      void 0,
                                      void 0,
                                      { hover: true }
                                    ]
                                  ])
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_16, _toDisplayString(element.id), 1),
                            _createElementVNode("td", _hoisted_17, [
                              _createTextVNode(_toDisplayString(element.name) + " ", 1),
                              (_ctx.providerRatingEnabled)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(["badge me-1", _ctx.getRatingBadgeClass(element)])
                                  }, _toDisplayString(_ctx.helper.trans(`labels.provider_rating_badge_${_ctx.getRatingBadge(element)}`)), 3))
                                : _createCommentVNode("", true),
                              (element.isAsync)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, " 🔀"))
                                : _createCommentVNode("", true),
                              (element.isBothSide)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, " ↕️"))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", null, [
                              (element.config.currency)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(element.config.currency), 1))
                                : _createCommentVNode("", true),
                              (element.config.minSum)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.helper.trans('labels.from_limit', {sum: _ctx.numberFormatter.formatMoney(element.config.minSum), currency: ''})), 1))
                                : _createCommentVNode("", true),
                              (element.config.maxSum)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.helper.trans('labels.to_limit', {sum: _ctx.numberFormatter.formatMoney(element.config.maxSum), currency: ''})), 1))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.config.paymentOptions, (option) => {
                                return (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.helper.trans('payment_options.' + option)), 1))
                              }), 256)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.config.paymentMethods, (method) => {
                                return (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.helper.trans('pay_methods.' + method)), 1))
                              }), 256))
                            ]),
                            _createElementVNode("td", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.showEditModal(element)),
                                  class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                                }, [
                                  _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fa fa-pencil" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.edit')), 1)
                                ], 8, _hoisted_27),
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.showDeleteModal(element)),
                                  class: "btn btn-sm btn-outline-danger text-nowrap text-capitalize"
                                }, [
                                  _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fa fa-trash" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.delete')), 1)
                                ], 8, _hoisted_28)
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["list"])
                    ])
                  ]),
                  _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}